export default "__VITE_ASSET__KDF_hUYr__";